import Decimal from "decimal.js";

export default class Coupon {

  constructor(data = {}) {
    this.setData(data);
  }

  setData(data = {}) {
    this.id = data.id || undefined;
    this.name = data.name || undefined;
    this.code = data.code || undefined;
    this.discountType = (data.discount && data.discount.discountType) || undefined;
    this.discountValue = (data.discount &&  Number(data.discount.discountValues)) || 0;
    this.maxDiscountValues = (data.discount && Number(data.discount.maxDiscountValues)) || 0;
    this.error = data.errorCode || undefined;
    this.isValid = data.isValid || false;
    this.couponCode = data.couponCode || undefined;
    this.productValue = data.discount && data.discount.productValue ? data.discount.productValue : [];
  }

  getDiscountPrice(inputPrice, allowLessThanZero = false) {
    if (inputPrice <= 0 || this.discountValue <= 0) return inputPrice;
    const price = new Decimal(inputPrice);
    let discountPrice;
    if (this.discountType === 'PERCENTAGE') {
      discountPrice = price.mul((100 - this.discountValue) / 100);
    } else if (this.discountType === 'MONEY') {
      discountPrice = price.sub(this.discountValue)
    }
    return Number(discountPrice) < 0 && !allowLessThanZero ? 0 : discountPrice;
  }

  getDiscountValue(totalPrice) {
    if (totalPrice <= 0 || this.discountValue <= 0) return 0;
    const discountPrice = this.getDiscountPrice(totalPrice, true);
    return new Decimal(totalPrice).sub(discountPrice);
  }

  isPercentType() {
    return this.discountType === 'PERCENTAGE'
  }

}